import request from '../helper/request'

// 获取联系人列表（前3条）
export function getContactList(params) {
  return request({
    url: '/api/getContactList/',
    method: 'post',
    data: params
  })
}

// 新增联系人
export function addContact(data) {
  return request({
    url: '/api/addContact/',
    method: 'post',
    data: data
  })
}

export function addUserContact(data) {
  return request({
    url: '/api/addUserContact/',  // 注意带斜杠
    method: 'post',
    data: data
  });
}

// 修改联系人
export function updateContact(data) {
  return request({
    url: '/api/updateContact/',
    method: 'post',
    data: data
  })
}

// 删除联系人
export function deleteContact(data) {
  return request({
    url: '/api/deleteContact/',
    method: 'post',
    data: data
  })
}